module.exports = __webpack_public_path__ + "img/course116.9123cb4e.png";